import React from 'react';

const QuizSelect = ({ component, slideCode, value, options, onChange }) => {
  const isCountry = component.name === 'country';

  return (
    <select
      key={`sel-${slideCode}-${component.name}`}
      id={component.name}
      className="t-w-full t-py-4 t-px-3.5 t-pr-9 t-border-2 t-border-g200 t-rounded-xl t-font-sans t-text-base t-text-navy t-bg-white t-outline-none focus:t-border-quiz-teal t-cursor-pointer t-appearance-none t-bg-[url('data:image/svg+xml,%3Csvg%20width%3D%2712%27%20height%3D%278%27%20viewBox%3D%270%200%2012%208%27%20fill%3D%27none%27%20xmlns%3D%27http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%27%3E%3Cpath%20d%3D%27M1%201.5L6%206.5L11%201.5%27%20stroke%3D%27%23BDBDBD%27%20stroke-width%3D%272%27%20stroke-linecap%3D%27round%27%20stroke-linejoin%3D%27round%27%2F%3E%3C%2Fsvg%3E')] t-bg-no-repeat t-bg-[position:right_12px_center]"
      {...(isCountry ? { value: value ?? '' } : {})}
      onChange={(e) => {
        e.preventDefault();
        onChange(e.target.value);
      }}
    >
      {options.map((opt) => (
        <option key={opt.value || 'ph'} value={opt.value}>
          {opt.label}
        </option>
      ))}
    </select>
  );
};

export default React.memo(QuizSelect);
